import { SampleResultStatusEnum } from 'src/app/features/orders/_shared/_enums';

export const sampleResultStatusNames: Record<SampleResultStatusEnum, string> = {
    [SampleResultStatusEnum.DEFAULT]: 'status.all',
};

export const sampleResultStatusNamesTooltips: Record<SampleResultStatusEnum, string> = {
    [SampleResultStatusEnum.DEFAULT]: 'status.all',
};
